<template>
    <div class="p-3">
        <el-card header="Enviar Mensagem a todos clientes">
            <ElForm label-position="top">
                <el-form-item label="Mensagem a enviar" prop="description">
                    <el-input type="textarea" name="message" v-model="message" :minlength="1" :maxlength="300" placeholder="Escreva a mensagem" :rows="7" clearable />
                </el-form-item>
                <ElButton :disabled="message.trim().length <= 0 || loading" :loading="loading" @click="send">
                    Enviar mensagem
                </ElButton>
            </ElForm>
        </el-card>
    </div>
</template>

<script lang="ts" setup>
    import Api from '@/services/api';
    import { ElForm, ElInput } from 'element-plus';
    import { ref } from 'vue';

    const message = ref<string>('')
    const loading = ref<boolean>(false)

    const send = async () => {
        loading.value = true
        try {
            const res = await Api.post('/admin/send-message', {message: message.value})
            console.log(res)
            alert("Mensagem enviada a todos usuarios")
        } catch(e) {
            alert("Ocorreu um erro")
        } finally {
            loading.value = false
        }
    }
</script>